module.exports = __webpack_public_path__ + "img/avatar-s-23.b96f648e.jpg";